import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const JOBACCESS30MINTRANSITDIFF_LAYER_ID = 'jobAccess30MinTransitDiffLayer';

const layerConfig = {
  title: 'Job Access 30 Minute Transit Difference',
};

function JobAccess30MinTransitDiffLayer() {
  const dispatch = useDispatch();
  const { jobAccess30MinTransitDiffLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, jobAccess30MinTransitDiffLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (jobAccess30MinTransitDiffLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: JOBACCESS30MINTRANSITDIFF_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: jobAccess30MinTransitDiffLayer.visible,
      opacity: jobAccess30MinTransitDiffLayer.opacity,
      getFillColor: colorBins({
        attr: 'job_access_30minute_transit_diff',
        domain: [-18386, -5813.818, -3006.344, 0, 3000, 6000, 31870],
        colors: [
          [178, 34, 34],
          [255, 0, 0],
          [255, 102, 102],
          [255, 204, 204],
          [224, 224, 255],
          [153, 204, 255],
          [51, 102, 255],
          [0, 0, 128],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: JOBACCESS30MINTRANSITDIFF_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['job_access_30minute_transit_diff', 'geo_level_id'],
            }),
          };
        }
      },
    });
  }
}

export default JobAccess30MinTransitDiffLayer;
